"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['question', 'description', 'report'];
var initialValues = exports.initialValues = {
  question: '<p><strong>Look at the report:</strong></p>'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-stats"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (!values.report) {
    errors.report = 'You have to choose the report';
  }
  return errors;
};